/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_not_affiliated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse is not affiliated with Formula 1, the FIA, or the official F1 Fantasy game. Any F1-related data displayed on our platform is sourced from publicly available information.`)
};

const es_privacy_not_affiliated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse no está afiliado a Formula 1, la FIA ni al juego oficial F1 Fantasy. Cualquier dato relacionado con F1 mostrado en nuestra plataforma proviene de información disponible públicamente.`)
};

const de_privacy_not_affiliated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse ist nicht mit Formel 1, der FIA oder dem offiziellen F1 Fantasy Spiel verbunden. Alle auf unserer Plattform angezeigten F1-bezogenen Daten stammen aus öffentlich zugänglichen Informationen.`)
};

const nl_privacy_not_affiliated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse is niet gelieerd aan Formule 1, de FIA of het officiële F1 Fantasy-spel. Alle F1-gerelateerde gegevens die op ons platform worden weergegeven, zijn afkomstig uit openbaar beschikbare informatie.`)
};

const fr_privacy_not_affiliated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse n’est pas affilié à la Formule 1, la FIA ou le jeu F1 Fantasy officiel. Toutes les données liées à la F1 affichées sur notre plateforme proviennent d’informations accessibles au public.`)
};

const it_privacy_not_affiliated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse non è affiliato alla Formula 1, alla FIA o al gioco ufficiale F1 Fantasy. Qualsiasi dato relativo alla F1 visualizzato sulla nostra piattaforma proviene da informazioni pubblicamente disponibili.`)
};

const pt_br2_privacy_not_affiliated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Toolverse não é afiliada à Fórmula 1, à FIA ou ao jogo oficial F1 Fantasy. Quaisquer dados relacionados à F1 exibidos em nossa plataforma são obtidos de informações publicamente disponíveis.`)
};

const pt_privacy_not_affiliated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Toolverse não está afiliada à Fórmula 1, FIA ou ao jogo oficial F1 Fantasy. Quaisquer dados relacionados com F1 apresentados na nossa plataforma são obtidos de informação publicamente disponível.`)
};

const ja_privacy_not_affiliated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ToolverseはFormula 1、FIA、公式F1ファンタジーゲームとは提携していません。プラットフォーム上に表示されるF1関連データは公開情報から取得しています。`)
};

const zh_privacy_not_affiliated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse与F1、FIA或官方F1 Fantasy游戏无关。我们平台上显示的任何F1相关数据均来自公开信息。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_not_affiliated = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_not_affiliated(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_not_affiliated", locale)
	if (locale === "en") return en_privacy_not_affiliated(inputs)
	if (locale === "es") return es_privacy_not_affiliated(inputs)
	if (locale === "de") return de_privacy_not_affiliated(inputs)
	if (locale === "nl") return nl_privacy_not_affiliated(inputs)
	if (locale === "fr") return fr_privacy_not_affiliated(inputs)
	if (locale === "it") return it_privacy_not_affiliated(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_not_affiliated(inputs)
	if (locale === "pt") return pt_privacy_not_affiliated(inputs)
	if (locale === "ja") return ja_privacy_not_affiliated(inputs)
	return zh_privacy_not_affiliated(inputs)
};